module.exports = __webpack_public_path__ + "static/media/send_icon.79fae2d5.svg";